export default __webpack_public_path__ + "static/media/axn_logo_supernova.74b18cce.svg";